import { render, staticRenderFns } from "./states-data.vue?vue&type=template&id=66b2dd62"
import script from "./states-data.vue?vue&type=script&lang=js"
export * from "./states-data.vue?vue&type=script&lang=js"
import style0 from "./states-data.vue?vue&type=style&index=0&id=66b2dd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports